import axios from "axios";
import utils from "./utils";

import "@stimulus/polyfills";
import { Application } from "stimulus";

const application = Application.start();

export default function () {
  let globalSvg = "";
  let step = 0;
  var MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
  var md5 = MD5(Date.now());

  function hideCBvalue(value) {
    let cbToHide = document.querySelectorAll(`[value="${value}"]`);
    let form = getChoosenForm();

    if (form == "Drób") {
      for (let i = 0; i < cbToHide.length; i++) {
        const element = cbToHide[i];
        element.parentNode.classList.remove("checkbox-disabled");
      }
    } else if (form == "Trzoda chlewna") {
      for (let i = 0; i < cbToHide.length; i++) {
        const element = cbToHide[i];
        element.parentNode.classList.remove("checkbox-disabled");
      }
    } else if (form == "Bydło") {
      for (let i = 0; i < cbToHide.length; i++) {
        const element = cbToHide[i];
        element.parentNode.classList.remove("checkbox-disabled");
      }
    } else if (form == "Konie") {
      for (let i = 0; i < cbToHide.length; i++) {
        const element = cbToHide[i];
        element.parentNode.classList.remove("checkbox-disabled");
      }
    } else if (form == "Ogrodnictwo") {
      for (let i = 0; i < cbToHide.length; i++) {
        const element = cbToHide[i];
        element.parentNode.classList.add("checkbox-disabled");
      }
    }
  }

  function handleFormConditions() {
    let form = getChoosenForm();

    function conditionalChecboxes(type = null) {
      let checkboxes = document.querySelectorAll("[data-checkbox-if]");
      for (let i = 0; i < checkboxes.length; i++) {
        const element = checkboxes[i];
        let att = element.getAttribute("data-checkbox-if");
        if (att != "null" && att) {
          element.classList.add("checkbox-disabled");
        }
      }
      if (type) {
        let showCheckboxes = document.querySelectorAll(
          `[data-checkbox-if="${type}"]`
        );

        for (let i = 0; i < showCheckboxes.length; i++) {
          const element = showCheckboxes[i];
          element.classList.remove("checkbox-disabled");
        }
      }
    }

    function toggleField(visible = null, disabled) {
      let diseases = document.querySelectorAll(disabled);

      for (let i = 0; i < diseases.length; i++) {
        const element = diseases[i];
        if (visible == true) {
          element.classList.add("step-inactive");
          toggleValidation(element, "off", "off step-inactive");

          let diseasesInputs = element.querySelectorAll("input");
          for (let j = 0; j < diseasesInputs.length; j++) {
            const input = diseasesInputs[j];
            input.checked = false;
          }
        } else {
          element.classList.remove("step-inactive");
        }
      }
    }

    if (form) {
      // usun choroba albo pozostale szkody z pierwszego kroku dla koni i ogrodnictwa
      if (form == "Ogrodnictwo" || form == "Konie") {
        toggleField(true, ".disable-diseases");
        toggleField(true, ".is-ogrodnictwo-konie");
        toggleField(false, ".not-ogrodnictwo-konie");
      } else {
        toggleField(false, ".disable-diseases");
        toggleField(false, ".is-ogrodnictwo-konie");

        toggleField(true, ".not-ogrodnictwo-konie");
      }

      if (form == "Ogrodnictwo") {
        toggleField(false, ".disable-ogrodnictwo");
        toggleField(true, ".disable-when-ogrodnictwo");

        toggleField(false, ".show-when-ogrodnictwo");
        toggleField(true, ".hide-when-ogrodnictwo");

        toggleField(false, ".disable-when-konie");
        toggleField(true, ".only-konie");
      } else {
        toggleField(true, ".disable-ogrodnictwo");
        toggleField(false, ".disable-when-ogrodnictwo");

        toggleField(true, ".show-when-ogrodnictwo");
        toggleField(false, ".hide-when-ogrodnictwo");
      }

      if (form == "Konie") {
        toggleField(false, ".only-konie");
        toggleField(true, ".disable-when-ogrodnictwo");
        toggleField(true, ".disable-when-konie");
      }
      // show / hide checkboxes
      if (form == "Drób") {
        toggleField(false, ".disable-when-konie");
      }
      if (form == "Drób") {
        toggleField(false, ".disable-when-konie");
      }
      if (form == "Trzoda chlewna") {
        toggleField(false, ".disable-when-konie");
      }
      if (form == "Bydło") {
        toggleField(false, ".disable-when-konie");
      }
      conditionalChecboxes();

      let toggleOn;

      if (form == "Drób") {
        conditionalChecboxes("drob");
        toggleOn = document.querySelectorAll(
          ".disable-diseases, .on-dieasesCb [data-checked-show='when_diseases']"
        );
      } else if (form == "Trzoda chlewna") {
        conditionalChecboxes("trzoda");
        toggleOn = document.querySelectorAll(
          ".disable-diseases, .on-dieasesCb [data-checked-show='when_diseases']"
        );
      } else if (form == "Bydło") {
        conditionalChecboxes("bydlo");
        toggleOn = document.querySelectorAll(
          ".disable-diseases, .on-dieasesCb [data-checked-show='when_diseases']"
        );
      } else if (form == "Konie") {
        conditionalChecboxes("koni");
        toggleOn = document.querySelectorAll(".only-konie");
      } else if (form == "Ogrodnictwo") {
        conditionalChecboxes("koni");
        toggleOn = document.querySelectorAll(".show-when-ogrodnictwo");
      }
      hideCBvalue("Inspekcja Weterynaryjna");
      for (let i = 0; i < toggleOn.length; i++) {
        const element = toggleOn[i];
        toggleValidation(element, "on", "");
      }
      document.querySelector(".sec-toggle-step").classList.add("active");
    }
  }

  function handleSteps() {
    let steps = document.querySelectorAll(".step");

    let nextStep = document.querySelectorAll(".next-step:not(.prevent)");
    let prevStep = document.querySelectorAll(".prev-step");

    if (!steps[step]) {
      return;
    }
    steps[step].classList.add("active");

    for (let i = 0; i < nextStep.length; i++) {
      const element = nextStep[i];
      element.addEventListener("click", handleNextStep);
    }

    for (let i = 0; i < prevStep.length; i++) {
      const element = prevStep[i];
      element.addEventListener("click", handlePrevStep);
    }

    function checkFistStep() {
      let inputs = document.querySelectorAll(".validate-first-cb input"),
        radios = document.querySelectorAll(".validate-first-rd input"),
        radiosValid = false,
        checkboxesValid = false;

      for (let i = 0; i < inputs.length; i++) {
        const element = inputs[i];
        if (element.checked) {
          checkboxesValid = true;
        }
      }

      for (let j = 0; j < radios.length; j++) {
        const element = radios[j];
        if (element.checked) {
          radiosValid = true;
        }
        if (element.closest(".step-inactive")) {
          radiosValid = true;
        }
      }

      return checkboxesValid && radiosValid ? true : false;
    }

    function handleNextStep(e) {
      e.preventDefault();
      if (steps[step] && checkFistStep()) {
        step += 1;
        for (let i = 0; i < steps.length; i++) {
          const element = steps[i];
          element.classList.remove("active");
        }

        if (steps[step]) {
          steps[step].classList.add("active");
        }
      } else {
        utils.message("Zaznacz przedmiot ubezpieczenia", "error");
      }
    }

    function handlePrevStep(e) {
      e.preventDefault();
      if (steps[step]) {
        step -= 1;
        for (let i = 0; i < steps.length; i++) {
          const element = steps[i];
          element.classList.remove("active");
        }
        if (steps[step]) {
          steps[step].classList.add("active");
        }
      }
    }
  }
  function handleStepIcon() {
    let icons = document.querySelectorAll(".step-icon");

    for (let i = 0; i < icons.length; i++) {
      const element = icons[i];
      element.addEventListener("click", function (e) {
        if (!e.isTrusted) {
          return;
        }
        if(typeof e.pointerType == 'undefined') {
          return;
        } 

        let input = element.querySelector("input");
        if (element.querySelector("svg")) {
          globalSvg = element.querySelector("svg").outerHTML;
          setTimeout(function () {
            console.log("dispatch", input);
            var ev = document.createEvent("MouseEvents");
            ev.initMouseEvent("click", true, false, self, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            // Fire event
            input.dispatchEvent(ev);
          }, 100);
          applySvg(globalSvg);
        }
      });
    }
  }

  function applySvg(svg) {
    let icons = document.querySelectorAll(".step-indicator__icon-icon");
    for (let i = 0; i < icons.length; i++) {
      const element = icons[i];
      if(svg) {
        element.innerHTML = svg;
      }
    }
  }

  function validateSteps() {
    let steps = document.querySelectorAll(".step");
    let inputs = steps.querySelectorAll;
  }

  function appendEnteredData() {}

  function formDataHandler() {
    function allCheckedString(to) {
      let str = "";
      let cb = document.querySelectorAll(`[name="${to}"]`);

      for (let i = 0; i < cb.length; i++) {
        const element = cb[i];
        if (element.checked) {
          str += element.value + ", ";
        }
      }
      str = str.substring(0, str.length - 1);
      str = str.substring(0, str.length - 1);
      return str;
    }

    let form = document.querySelector(".ajax-form");
    if (!form) {
      return;
    }
    form.addEventListener("submit", function (e) {
      let formData = Object.values(form).reduce((obj, field) => {
        if (field.nodeType) {
          let sort = field.getAttribute("data-sort") || 0;

          if (
            field.getAttribute("type") == "radio" ||
            field.getAttribute("type") == "checkbox"
          ) {
            if (field.checked) {
              obj[field.name] = [allCheckedString(field.name), sort];
            }
          } else {
            if (field.value && field.value != "Wybierz") {
              obj[field.name] = [field.value, sort];
            }
          }
        }
        return obj;
      }, {});
      handleFormData(formData);
      e.preventDefault();
    });

    function sendData(item) {
      var data = new FormData();

      let btn = document.querySelector('.last-step [type="submit"]');
      btn.classList.add("inactive");

      for (var key in item) {
        data.append(key, item[key]);
      }
      data.append("file_hash", md5);

      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      axios.post(siteurl, data).then((response) => {
        if (response.data == "allgood") {
          window.location.replace(thankYouPage);
        }
        btn.classList.remove("inactive");
      });
    }

    function goToStep(step) {
      let steps = document.querySelectorAll(".step");
      for (let i = 0; i < steps.length; i++) {
        const element = steps[i];
        element.classList.remove("active");
      }
      document.getElementById("whole-ajax-form").scrollIntoView();
      steps[step].classList.add("active");
    }

    function handleFormData(data) {
      if (validateFormData()) {
        if (validateTerms()) {
          sendData(data);
        } else {
          utils.message(
            "Zaznacz zgody i potwierdź, że nie jesteś robotem",
            "error"
          );
        }
      } else {
        step = 0;
        goToStep(step);
        utils.message("Uzupełnij wszystkie pola", "error");
      }
    }

    function validateTerms() {
      let terms = document.querySelectorAll(".v-term");
      let valid = true;
      for (let i = 0; i < terms.length; i++) {
        const element = terms[i];
        if (!element.checked) {
          valid = false;
          element.parentElement.classList.add("error");
        }
      }

      let gc = document.querySelector("#recaptchaValidator").value != "";
      if (!gc) {
        valid = false;
      }

      return valid;
    }

    function validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    function validatePhone(phone) {
      const re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
      return re.test(String(phone).toLowerCase());
    }

    function liveValidate() {
      let phone = document.querySelectorAll(
        ".form input[type='tel'], .form .email"
      );
      let notValidTooltip = `<span class="not-valid-tooltip"></span>`;
      let notValidMsg = `<span class="not-valid">Uzupełnij poprawnie</span>`;

      for (let i = 0; i < phone.length; i++) {
        const element = phone[i];
        let parent = element.parentElement.querySelector(".v-msg");
        element.addEventListener("keyup", function () {
          let type = element.getAttribute("type");
          if (type == "tel") {
            if (element.value && !validatePhone(element.value)) {
              if (!parent.querySelector(".not-valid")) {
                parent.insertAdjacentHTML("beforeEnd", notValidMsg);
                parent.insertAdjacentHTML("beforeEnd", notValidTooltip);
              }
            } else {
              if (parent.querySelector(".not-valid")) {
                let not_valid = parent.querySelectorAll(
                  ".not-valid, .not-valid-tooltip"
                );
                for (let nv = 0; nv < not_valid.length; nv++) {
                  const element = not_valid[nv];
                  element.remove();
                }
              }
            }
          } else if (type == "email") {
            if (element.value && !validateEmail(element.value)) {
              if (!parent.querySelector(".not-valid")) {
                parent.insertAdjacentHTML("beforeEnd", notValidMsg);
                parent.insertAdjacentHTML("beforeEnd", notValidTooltip);
              }
            } else {
              if (parent.querySelector(".not-valid")) {
                let not_valid = parent.querySelectorAll(
                  ".not-valid, .not-valid-tooltip"
                );
                for (let nv = 0; nv < not_valid.length; nv++) {
                  const element = not_valid[nv];
                  element.remove();
                }
              }
            }
          }
        });
      }
    }
    liveValidate();

    function validateFormData() {
      let valid = true;
      let step = document.querySelector(".step.active");
      let inputs = step.querySelectorAll(
        ".form input[type='text'], .form input[type='tel'], .form .email"
      );

      let selects = step.querySelectorAll("select");

      let validateCheckboxes = document.querySelectorAll(".validate-cb");

      let messages = [];
      messages["checkbox"] = "Zaznacz przynajmniej jedną opcję";
      messages["radio"] = "Zaznacz opcję";
      messages["text"] = "Uzupełnij pole";
      messages["email"] = "Nieprawidłowy adres email";
      messages["tel"] = "Nieprawidłowy numer telefonu";

      for (let s = 0; s < selects.length; s++) {
        const element = selects[s];
        let parent = element.parentNode;
        let notValidMsg = `<span class="not-valid">${messages["radio"]}</span>`;

        if (
          element.value == "Wybierz" &&
          element.hasAttribute("data-validate")
        ) {
          parent.insertAdjacentHTML("beforeEnd", notValidMsg);
        }
      }

      for (let i = 0; i < inputs.length; i++) {
        const texts = inputs[i];
        let type = texts.getAttribute("type");
        let isRequired = texts.getAttribute("temp-required");

        let parent = texts.parentElement;
        let notValidMsg = `<span class="not-valid">${messages[type]}</span>`;
        let notValidTooltip = "";
        if (type == "email" || type == "text" || type == "tel") {
          notValidTooltip = `<span class="not-valid-tooltip"></span>`;
        }

        if (isRequired != null) {
          if (!texts.value) {
            valid = false;

            if (!parent.querySelector(".not-valid")) {
              parent.insertAdjacentHTML("beforeEnd", notValidMsg);
              parent.insertAdjacentHTML("beforeEnd", notValidTooltip);
            }
          } else {
            if (parent.querySelector(".not-valid")) {
              let not_valid = parent.querySelectorAll(
                ".not-valid, .not-valid-tooltip"
              );
              for (let nv = 0; nv < not_valid.length; nv++) {
                const element = not_valid[nv];
                element.remove();
              }
            }
          }

          if (type == "email") {
            if (!validateEmail(texts.value)) {
              valid = false;

              if (!parent.querySelector(".not-valid")) {
                parent.insertAdjacentHTML("beforeEnd", notValidMsg);
                parent.insertAdjacentHTML("beforeEnd", notValidTooltip);
              }
            }
          }

          var post_regex = /^[0-9]{2}-[0-9]{3}$/;
          if (texts.classList.contains("code") == true) {
            if (!post_regex.test(texts.value)) {
              valid = false;
              if (!parent.querySelector(".not-valid")) {
                parent.insertAdjacentHTML("beforeEnd", notValidMsg);
                parent.insertAdjacentHTML("beforeEnd", notValidTooltip);
              }
            }
          }
          if (type == "tel") {
            if (!validatePhone(texts.value)) {
              valid = false;

              if (!parent.querySelector(".not-valid")) {
                parent.insertAdjacentHTML("beforeEnd", notValidMsg);
                parent.insertAdjacentHTML("beforeEnd", notValidTooltip);
              }
            }
          }
        }
      }

      for (let i = 0; i < validateCheckboxes.length; i++) {
        let group = validateCheckboxes[i];
        let groupInputs = group.querySelectorAll("input");
        let groupValid = false;
        let type;
        for (let j = 0; j < groupInputs.length; j++) {
          const element = groupInputs[j];
          type = element.getAttribute("type");
          if (element.checked) {
            groupValid = true;
          }
        }
        let notValidMsg = `<span class="not-valid">${messages[type]}</span>`;

        if (!groupValid) {
          if (!group.querySelector(".not-valid")) {
            group.insertAdjacentHTML("beforeEnd", notValidMsg);
          }
          valid = false;
        } else {
          if (group.querySelector(".not-valid")) {
            let not_valid = group.querySelectorAll(
              ".not-valid, .not-valid-tooltip"
            );
            for (let nv = 0; nv < not_valid.length; nv++) {
              const element = not_valid[nv];
              element.remove();
            }
          }
        }
      }

      return valid;
    }

    let validateTrigger = document.querySelectorAll(".validate");
    let copyTrigger = document.querySelector(".copyData");
    copyTrigger.addEventListener("click", function () {
      copyToSummary();
    });
    // let validateTrigger = document.querySelectorAll(".menu-item-685");
    for (let i = 0; i < validateTrigger.length; i++) {
      const element = validateTrigger[i];
      element.addEventListener("click", function (e) {
        e.preventDefault();
        let gotostep = element.getAttribute("data-step");

        if (!validateFormData()) {
          var goto = gotostep ? gotostep : 1;
          goToStep(goto);
          utils.message("Uzupełnij wszystkie pola", "error");
        } else {
          if (gotostep) {
            var next = parseInt(gotostep) + 1;
            goToStep(next);
            step = next;
          }
        }
      });
    }
  }

  function copyToSummary() {
    let items = document.querySelectorAll("[data-apply-to]");

    function getCheckedStr(to) {
      let str = "";
      let cb = document.querySelectorAll(`[data-apply-to=${to}]`);
      for (let i = 0; i < cb.length; i++) {
        const element = cb[i];
        let parent = element.closest("li");
        if (!parent.classList.contains("checkbox-disabled")) {
          if (element.checked) {
            str += element.value + ", ";
          }
        }
      }
      str = str.substring(0, str.length - 1);
      str = str.substring(0, str.length - 1);
      return str;
    }
    function showIfValue() {
      let items = document.querySelectorAll(".last-step [data-apply]");
      for (let i = 0; i < items.length; i++) {
        const element = items[i];
        const parent = element.closest(".step__summary-item");
        let text = element.innerHTML;
        if (text != "" && text != "Wybierz") {
          parent.classList.add("active");
        }
      }
    }

    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      let apply = element.getAttribute("data-apply-to");
      let type = element.getAttribute("type");

      let applyTo = document.querySelectorAll(
        `.last-step [data-apply="${apply}"]`
      );

      if (applyTo) {
        for (let e = 0; e < applyTo.length; e++) {
          const applyEl = applyTo[e];

          if (element.value) {
            if (applyTo) {
              if (type == "checkbox" || type == "radio") {
                let str = getCheckedStr(apply);
                if (str) {
                  applyEl.innerHTML = getCheckedStr(apply);
                }
              } else {
                applyEl.innerHTML = element.value;
              }
            }
          }
        }
      }
    }

    setTimeout(function () {
      showIfValue();
    }, 500);
  }

  function toggleValidation(parent, enable) {
    let inputs = parent.querySelectorAll(
      ".form input[type='text'], .form input[type='tel'], .form .email"
    );
    let checkboxes = parent.querySelectorAll(".radio-list");

    for (let i = 0; i < checkboxes.length; i++) {
      const element = checkboxes[i];
      if (enable == "off") {
        element.classList.remove("validate-cb");
      }
      if (enable == "on") {
        element.classList.add("validate-cb");
      }
    }

    for (let i = 0; i < inputs.length; i++) {
      const element = inputs[i];
      if (enable == "off") {
        element.removeAttribute("temp-required");
      }
      if (enable == "on") {
        let name = element.getAttribute("name");
        if (
          name != "Numer i seria dowodu osobistego" &&
          name != "Numer i seria dowodu osobistego ubezpieczonego"
        ) {
          element.setAttribute("temp-required", "true");
        }
      }
    }
  }

  function conditionalFields(parent) {
    let conditional = parent.querySelectorAll("[data-is-checked-show]");

    function clearFields(el) {
      let fields = el.querySelectorAll("input, textarea, select");
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        element.value = "";
        element.checked = false;
      }
    }

    function clearCesja() {
      let cesja = parent.querySelectorAll('[data-is-checked-show="cesja,0"]');
      for (let i = 0; i < cesja.length; i++) {
        const element = cesja[i];
        if (element.checked) {
          let hide = document.querySelectorAll(
            '[data-checked-show="os_fizyczna"], [data-checked-show="os_prawna"], [data-checked-show="cesja"]'
          );

          for (let j = 0; j < hide.length; j++) {
            const child = hide[j];
            child.classList.remove("coresponding_active");
            let inputs = child.querySelectorAll("input");
            for (let h = 0; h < inputs.length; h++) {
              const input = inputs[h];
              let type = input.getAttribute("type");
              if (type == "text") {
                input.value = "";
              } else {
                //input.attr("checked");
                input.checked = false;
              }
            }
          }
        }
      }
    }

    function checkCorespon(element) {
      let allEls = parent.querySelectorAll("[data-is-checked-show]");
      let allCoresponding = parent.querySelectorAll("[data-checked-show]");

      for (let i = 0; i < allCoresponding.length; i++) {
        const element = allCoresponding[i];
        let corp = element.getAttribute("data-checked-show");

        element.classList.remove("coresponding_active");
        toggleValidation(element, "off", "off checkCorespon");

        setTimeout(function () {
          let isActive = parent.querySelector(
            `[data-is-checked-show="${corp},1"]`
          );

          if (isActive.checked == true) {
            element.classList.add("coresponding_active");
            toggleValidation(element, "on", "on checkCorespon");
          }
          if (i == allCoresponding.length - 1) {
            setTimeout(function () {
              clearCesja();
              
            }, 200);
          }
        }, 1000);
      }
    }

    for (let i = 0; i < conditional.length; i++) {
      const element = conditional[i];
      element.addEventListener("keyup", function () {
        checkCorespon(element);
      });
      element.addEventListener("change", function () {
        checkCorespon(element);
      });
      element.addEventListener("focus", function () {
        checkCorespon(element);
      });
    }
  }
  conditionalFields(document);

  function isSelectedConditional(parent) {
    let conditional = parent.querySelectorAll(
      "[data-show-is-selected], [data-show-is-selected-sec]"
    );

    function checkCorespon() {
      let notCoresponding = parent.querySelectorAll(`[data-show-selected]`);

      for (let j = 0; j < notCoresponding.length; j++) {
        const element = notCoresponding[j];
        element.classList.remove("coresponding_active");
        toggleValidation(element, "off", "off coresponding_active");
      }

      for (let z = 0; z < conditional.length; z++) {
        const element = conditional[z];

        let val = element.value;
        let triggerEl = element.getAttribute("data-selected-trigger");

        let coresponding = parent.querySelectorAll(
          `[data-show-selected="${val}"][data-selected-element="${triggerEl}"]`
        );

        let type = element.getAttribute("type"),
          checked = element.checked;

        if (coresponding) {
          if (type == "checkbox" || type == "radio") {
            if (checked) {
              for (let i = 0; i < coresponding.length; i++) {
                const corp = coresponding[i];
                corp.classList.add("coresponding_active");
                toggleValidation(element, "on", "on coresponding_active");
              }
            }
          } else {
            for (let i = 0; i < coresponding.length; i++) {
              const corp = coresponding[i];
              corp.classList.add("coresponding_active");
              toggleValidation(element, "on", "on coresponding_active");
            }
          }
        }
      }
    }

    for (let i = 0; i < conditional.length; i++) {
      const element = conditional[i];
      element.addEventListener("change", function () {
        checkCorespon();
      });
    }
  }
  isSelectedConditional(document);

  function getChoosenForm() {
    let inputs = document.querySelectorAll(".validate-first-cb input"),
      firstStep;

    for (let i = 0; i < inputs.length; i++) {
      const element = inputs[i];
      if (element.checked) {
        firstStep = element.value;
      }
    }
    return firstStep;
  }

  function choosenFormListener() {
    let inputs = document.querySelectorAll(".validate-first-cb input, select");

    for (let i = 0; i < inputs.length; i++) {
      const element = inputs[i];
      element.addEventListener("change", function () {
        handleFormConditions();
      });
    }
  }
  choosenFormListener();

  function copyEnteredData() {
    function appendEnteredData(applyTo, value, attr) {
      let applyToEl = document.querySelector(`[${attr}="${applyTo}"]`);
      if (applyToEl && value) {
        applyToEl.value = value;

        if (applyToEl.tagName == "SELECT") {
          applyToEl.innerHTML = `<option value="${value}">${value}</option>`;
          var event = new Event("change");
          applyToEl.dispatchEvent(event);

          applyToEl
            .closest(".choices__inner")
            .querySelector("[aria-selected]").innerHTML = value;
        }
      }
    }

    let first_inputs = document.querySelectorAll("[data-copy-to]");
    let sec_inputs = document.querySelectorAll("[data-copy-insured-details]");

    for (let i = 0; i < first_inputs.length; i++) {
      const element = first_inputs[i];
      let val = element.value;
      let applyTo = element.getAttribute("data-copy-to");

      let copyToBoxOne = document.querySelector("#copy-data-one").checked;
      if (copyToBoxOne) {
        appendEnteredData(applyTo, val, "data-copy-insured-details");
      }
    }

    for (let i = 0; i < sec_inputs.length; i++) {
      const element = sec_inputs[i];

      let val = element.value;
      let applyTo = element.getAttribute("data-copy-insured-details");

      let copyToBoxTwo = document.querySelector("#copy-data-two").checked;

      if (copyToBoxTwo) {
        appendEnteredData(applyTo, val, "data-copy-address-details");
      }
    }
  }

  function copyEnteredDataHandler() {
    let els = document.querySelectorAll("#copy-data-one, #copy-data-two");
    for (let i = 0; i < els.length; i++) {
      const element = els[i];
      element.addEventListener("change", function () {
        copyEnteredData();
      });
    }
  }
  copyEnteredDataHandler();

  function appendFormatedFiles(obj) {
    let wellFormated = document.querySelector("input.well_formated");
    let str = "";
    if (!wellFormated) {
      return;
    }

    for (let i = 0; i < obj.length; i++) {
      const element = obj[i];
      if (element && element.url) {
        str += `<a style="color: #292929; margin: 0px; padding: 0px; font-family: Arial, Helvetica, sans-serif; font-size: 18px; line-height: 110%; font-weight: bold; text-decoration: none;" target="_blank" download href="${element.url}">${element.name}</a><br>`;
      }
    }

    wellFormated.value = str;
  }


  function uploadFile(files) {
    let formData = new FormData();
    let fileHTML = document.querySelector("input.files_html");

    [...files].forEach(function (file) {
      formData.append("file[]", file);
    });

    formData.append("action", "handle_insurance_files");
    formData.append("file_hash", md5);

    axios.post(ajaxurl, formData).then((response) => {
      if (response.data) {
        appendFormatedFiles(response.data);
        fileHTML.value = JSON.stringify(response.data);
      }
    });
  }

  let ifNoFilesContent = "";
  function handleFiles(files) {
    uploadFile(files);

    let bodycontent = document.querySelectorAll(".drag-drop__content");

    for (let j = 0; j < bodycontent.length; j++) {
      const content = bodycontent[j];

      ifNoFilesContent = content.innerHTML;
      content.innerHTML = "";

      for (var i = 0; i < files.length; i++) {
        const file = files[i];
        content.insertAdjacentHTML(
          "beforeEnd",
          `<div class="drag-drop__file"><strong>Przesłano:</strong> ${file.name} <div data-name="${file.name}" class="drag-drop__clear"></div></div>`
        );
      }
    }

    dragDropRemove();
  }

  var allfiles = [];
  function dropHandler(ev) {
    ev.preventDefault();

    if (ev.dataTransfer.files) {
      let dt = ev.dataTransfer;
      let files = dt.files;

      for (let f = 0; f < files.length; f++) {
        const element = files[f];
        allfiles.push(element);
      }
      handleFiles(allfiles);
    }
  }

  function dropFile() {
    let dragArea = document.querySelector(".drag-drop");
    if (!dragArea) {
      return;
    }
    let dragInput = document.querySelector(".drag-drop input[type='file']");
    let content = document.querySelector(".drag-drop__content");

    dragArea.addEventListener("drop", function (e) {
      dropHandler(e);
    });

    dragArea.addEventListener("dragover", function (e) {
      e.preventDefault();
      e.target.classList.add("dragover");
    });

    dragArea.addEventListener("dragexit", function (e) {
      e.preventDefault();
      e.target.classList.remove("dragover");
    });
    dragArea.addEventListener("dragleave", function (e) {
      e.preventDefault();
      e.target.classList.remove("dragover");
    });

    dragInput.addEventListener("change", function (e) {
      content.innerHTML = "";

      let files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        content.insertAdjacentHTML(
          "beforeEnd",
          `<div class="drag-drop__file"><strong>Przesłano:</strong> ${file.name} <div data-name="${file.name}" class="drag-drop__clear"></div></div>`
        );
        allfiles.push(file);

        handleFiles(allfiles);
      }
      dragDropRemove();
    });
  }

  function dragDropRemove() {
    let removers = document.querySelectorAll(".drag-drop__clear");
    if (!removers) {
      return;
    }

    for (let i = 0; i < removers.length; i++) {
      const element = removers[i];
      element.addEventListener("click", function (e) {
        let name = e.target.getAttribute("data-name");
        removeFile(name, e);
      });
    }
  }

  function removeFile(name, e) {
    let fileHTML = document.querySelector("input.files_html");
    let wellFormated = document.querySelector("input.well_formated");
    let value = fileHTML.value;

    if (!value || !name) {
      return;
    }

    for (let i = 0; i < allfiles.length; i++) {
      const element = allfiles[i];
      if (element.name == name) {
        allfiles.splice(i, 1);
      }
    }

    e.target.parentElement.remove();

    let obj = JSON.parse(value);

    for (let i = 0; i < obj.length; i++) {
      const element = obj[i];
      if (name && element) {
        if (element.name == name) {
          delete obj[i];
        }
      }
    }

    let newValue = JSON.stringify(obj);
    appendFormatedFiles(obj);

    fileHTML.value = newValue;
  }
  let copies = 1;
  function copyAddress() {
    let copyBtn = document.querySelectorAll(".another-address .button");
    copyBtn = copyBtn[copyBtn.length - 1];
    if (!copyBtn) {
      return;
    }
    copyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let copyContainer = document.querySelector(".copy-entire-step");
      let copyToContainer = document.querySelector(".copy-entire-step-body");

      let copySummaryContainer = document.querySelector(".copy-entire-summary");
      let copyToSummaryContainer = document.querySelector(
        ".copy-entire-summary-body"
      );

      var parser = new DOMParser();
      var dataHTMLDoc = parser.parseFromString(
        copyContainer.innerHTML,
        "text/html"
      );

      var summaryHTMLDoc = parser.parseFromString(
        copySummaryContainer.innerHTML,
        "text/html"
      );

      let summaryData = summaryHTMLDoc.querySelectorAll("[data-apply]");
      summaryHTMLDoc.querySelector(
        "h2"
      ).innerText = `Dodatkowy adres wystąpienia szkody - ${copies}`;
      for (let i = 0; i < summaryData.length; i++) {
        const element = summaryData[i];
        let current = element.getAttribute("data-apply");
        element.setAttribute("data-apply", current + copies);
      }

      dataHTMLDoc.querySelector(".checkbox-copy-data").remove();
      dataHTMLDoc.documentElement
        .querySelector("body")
        .insertAdjacentHTML("beforeEnd", '<div class="form-closer"></div>');
      let inputs = dataHTMLDoc.querySelectorAll("input");
      for (let i = 0; i < inputs.length; i++) {
        const element = inputs[i];
        if (element.getAttribute("name")) {
          let newName = `Dodatkowy adres szkody ${copies} - ${element.getAttribute(
            "name"
          )}`;
          let newSort = parseInt(element.getAttribute("data-sort")) + 10;

          if (
            element.parentElement.querySelector("label") &&
            element.parentElement.querySelector("label").getAttribute("for")
          ) {
            let newFor = element.getAttribute("id") + "cnew" + copies;
            let newId = element.getAttribute("id") + "cnew" + copies;

            element.parentNode
              .querySelector("label")
              .setAttribute("for", newFor);

            element.setAttribute("id", newId);
          }
          let newcopy =
            element.getAttribute("data-copy-address-details") + copies;
          let newapply = element.getAttribute("data-apply-to") + copies;
          element.setAttribute("data-copy-address-details", newcopy);
          element.setAttribute("data-apply-to", newapply);

          element.setAttribute("name", newName);
          element.setAttribute("data-sort", newSort);
        }
      }

      copyToContainer.append(dataHTMLDoc.documentElement);
      copyToSummaryContainer.append(summaryHTMLDoc.documentElement);
      copyToContainer.classList.add("active");
      let active = copyToContainer.querySelectorAll(".coresponding_active");

      for (let j = 0; j < active.length; j++) {
        const element = active[j];
        element.classList.remove("coresponding_active");
      }

      copyToContainer.addEventListener("click", function (e) {
        if (e.target.classList.contains("form-closer")) {
          e.target.closest("html").remove();
          if (copyToContainer.querySelectorAll("html").length == 0) {
            copyToContainer.classList.remove("active");
          }
        }
      });
      reInitSelectors(copyToContainer.querySelector("html:last-child"));
      conditionalFields(copyToContainer.querySelector("html:last-child"));
      isSelectedConditional(copyToContainer.querySelector("html:last-child"));
      hideCBvalue("Inspekcja Weterynaryjna");
      copyAddress();
      document.querySelector(".copiesCount").value = copies;

      copies += 1;
    });
  }

  function reInitSelectors(parent) {
    let formchoices = parent.querySelectorAll(".choices");
    for (let i = 0; i < formchoices.length; i++) {
      const parent = formchoices[i];
      parent.addEventListener("click", function () {
        parent
          .querySelector(".choices__list--dropdown")
          .classList.toggle("is-active");
      });

      let items = parent.querySelectorAll(".choices__item--choice");
      for (let j = 0; j < items.length; j++) {
        const element = items[j];
        element.addEventListener("click", function () {
          let parent = element.closest(".form__input");
          let val = element.innerHTML;
          val = val.replace(/(\r\n|\n|\r)/gm, "");
          val = val.trim();

          let selects = parent.querySelectorAll("select");
          for (let s = 0; s < selects.length; s++) {
            const element = selects[s];
            element.querySelector("option").setAttribute("value", val);
            element.querySelector("option").innerHTML = val;
          }
          parent.querySelector(".choices__item--selectable").innerHTML = val;
          setTimeout(function () {
            parent
              .querySelector(".choices__list--dropdown")
              .classList.remove("is-active");
          }, 500);
        });
      }
    }
  }

  function hilightIcon() {
    let icons = document.querySelectorAll(".step-icon");
    for (let i = 0; i < icons.length; i++) {
      const element = icons[i];

      element.addEventListener("click", function () {
        for (let i = 0; i < icons.length; i++) {
          const element = icons[i];
          element.classList.remove("active");
        }
        element.classList.add("active");
      });
    }
  }

  function cf7_switch() {
    let inputs = document.querySelectorAll(
      ".wpcf7-checkbox .wpcf7-list-item-label, .wpcf7-radio .wpcf7-list-item-label"
    );
    for (let i = 0; i < inputs.length; i++) {
      const element = inputs[i];
      element.addEventListener("click", function () {
        element.parentElement.querySelector("input").click();
      });
    }
  }

  function textAreaSubmit() {
    function submitOnEnter(event) {
      if (event.which === 13) {
        event.preventDefault(); // Prevents the addition of a new line in the text field (not needed in a lot of cases)
        document.querySelector(".ta-submit").click();
      }
    }
    let area = document.querySelector("textarea");
    if (area) {
      area.addEventListener("keypress", submitOnEnter);
    }
  }

  function fixTabIndex() {
    let els = document.querySelectorAll("[data-sort]");
    for (let i = 0; i < els.length; i++) {
      const element = els[i];
      let index = element.getAttribute("data-sort");
      element.setAttribute("tabindex", index);
    }
  }

  function liveValidateInputs() {
    function clearError(e) {
      if (e.target.value) {
        let parentEl = e.target.closest(".form__input");
        if (parentEl != null && parentEl.nodeType) {
          let parentEl1 = parentEl.querySelectorAll(".not-valid");
          let parentEl2 = parentEl.querySelectorAll(".not-valid-tooltip");
          if (parentEl1) {
            for (let i = 0; i < parentEl1.length; i++) {
              const element = parentEl1[i];
              element.remove();
            }
          }
          if (parentEl2) {
            for (let i = 0; i < parentEl2.length; i++) {
              const element = parentEl2[i];
              element.remove();
            }
          }
        }
      }
    }
    document.addEventListener("change", function (e) {
      clearError(e);
    });
    document.addEventListener("keyup", function (e) {
      clearError(e);
    });
  }

  function multilineInnput() {
    let area = document.querySelector(".multilineinput textarea");
    let input = document.querySelector(".multilineinput input");
    area.addEventListener("keyup", function () {
      input.value = area.value;
    });
  }

  function preventEnter() {
    window.addEventListener(
      "keydown",
      function (e) {
        if (
          e.keyIdentifier == "U+000A" ||
          e.keyIdentifier == "Enter" ||
          e.keyCode == 13
        ) {
          if (e.target.nodeName == "INPUT") {
            e.preventDefault();
            return false;
          }
        }
      },
      true
    );
  }

  let ajaxForm = document.querySelector(".ajax-form");
  if (ajaxForm) {
    multilineInnput();
    liveValidateInputs();
    fixTabIndex();
    copyAddress();
    handleSteps();
    handleStepIcon();
    validateSteps();
    appendEnteredData();
    copyEnteredData();
    formDataHandler();
    hilightIcon();
    preventEnter();
  }
  textAreaSubmit();
  dropFile();
  cf7_switch();
}
